import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import {
  KennitalaInput as UiKennitalaInput,
  useInputValidation,
} from '@landsbankinn/ui';
import React from 'react';

const res = {
  kennitalaNotFound: {
    is: 'Kennitala finnst ekki í þjóðskrá',
    en: 'Id. No. not found',
  },
  errorMessage: {
    is: 'Kennitala er ekki á réttu formi',
  },
};

const Host = styled.div`
  position: relative;
`;

interface IProps {
  placeholder: string;
  onChange: (val: string) => void;
  value?: string;
  kennitalaNotFound?: boolean;
}

export function KennitalaInput({
  placeholder,
  onChange,
  value,
  kennitalaNotFound,
}: IProps) {
  const { r } = useResource();
  const [ref, isValid, errorMessage] = useInputValidation(
    value,
    [
      {
        validation: (val) => !!val && val.length === 10,
        message: r(res.errorMessage),
      },

      {
        validation: () => !kennitalaNotFound,
        message: r(res.kennitalaNotFound),
      },
    ],
    [kennitalaNotFound],
  );

  return (
    <Host>
      <UiKennitalaInput
        variant="noBorder"
        labelVariant="aboveInput"
        errorMessageVariant="insideInput"
        errorMessage={errorMessage}
        aria-required
        inputRef={ref}
        label={placeholder}
        value={value}
        type="tel"
        isValid={isValid}
        onChange={(e) => onChange(e.currentTarget.value.replace('-', ''))}
      />
    </Host>
  );
}
